import { ConditionRegistryCategory } from '../../ConditionRegistryCategory';
import { ConditionRegistryItem } from '../../ConditionRegistryItem';
import { runtime } from '../../../../classes/runtime/Runtime';
export class ConditionRegistryRuntimeInfo extends ConditionRegistryCategory {
    label = 'Info';
    constructor(parent) {
        super(parent);
        super.init();
    }
    isBrowserRuntime = () => new ConditionRegistryItem({
        eval: () => runtime.isBrowserRuntime,
    });
    isServerRuntime = () => new ConditionRegistryItem({
        eval: () => runtime.isServerRuntime,
    });
    isSmartphone = () => new ConditionRegistryItem({
        eval: () => !!runtime.browserRuntime && runtime.browserRuntime.browserDevice.isSmartphone,
    });
    isTabletOrSmartphone = () => new ConditionRegistryItem({
        eval: () => !!runtime.browserRuntime && runtime.browserRuntime.browserDevice.isTabletOrSmartphone,
    });
    isMobileAppWebView = () => new ConditionRegistryItem({
        eval: ({ app }) => app.appInfo.isMobileAppWebView,
    });
    /*
    readonly isCookieConsentPending = () =>
      new ConditionRegistryItem({
        eval: ({ app }) =>
          !!runtime.browserRuntime &&
          !app.appInfo.isMobileAppWebView &&
          runtime.browserRuntime.app.appCookies.reactiveCookies.get('cookieconsent_status') !== 'dismiss'
      });
  */
    shouldTriggerFullscreen = () => new ConditionRegistryItem({
        eval: ({ app }) => runtime.browserRuntime.browserFullscreen.shouldTriggerFullscreen,
    });
}
